export default __webpack_public_path__ + "static/media/mockScythe.86abff30.png";